import { CommonModule } from '@angular/common';
import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import {
  DsButtonV2Component,
  DsIconButtonV2Component,
  DsIconComponent,
  DsIconName,
} from '@customdesignsystem';
import { ROUTING_REFORMA_PENSIONES } from '@constants/url.constant';
import { ModalService } from '@services/modal/modal.service';

interface PiBonoOpcion {
  icon: DsIconName;
  condition: string;
  conditionBold: string;
  result: string;
}

/**
 * Modal “Bono Amortizable” — Figma (confirmación paso 0).
 */
@Component({
  selector: 'app-pi-modal-bono-amortizable',
  standalone: true,
  imports: [CommonModule, DsIconComponent, DsIconButtonV2Component, DsButtonV2Component],
  templateUrl: './pi-modal-bono-amortizable.component.html',
  styleUrls: ['./pi-modal-bono-amortizable.component.scss'],
})
export class PiModalBonoAmortizableComponent {
  readonly ctaLabel = 'Confirmar';

  readonly opciones: PiBonoOpcion[] = [
    {
      icon: 'MoneyBag',
      condition: 'Si te pensionas ',
      conditionBold: 'antes de diciembre 2027',
      result: 'Se paga en una sola cuota',
    },
    {
      icon: 'Payments',
      condition: 'Si te pensionas ',
      conditionBold: 'después de diciembre 2027',
      result: 'Se paga en cuotas mensuales',
    },
  ];

  constructor(
    private readonly modalService: ModalService,
    private readonly router: Router,
  ) {}

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    this.cerrar();
  }

  cerrar(): void {
    void this.modalService.closeModal({ confirmed: false }, 'cancel');
  }

  confirmar(): void {
    void this.modalService.closeModal({ confirmed: true }, 'confirm');
  }

  irAReformaPensiones(event: Event): void {
    event.preventDefault();
    this.cerrar();
    void this.router.navigate([`/${ROUTING_REFORMA_PENSIONES.REFORMA_PENSIONES_BASE}`]);
  }
}
